import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import avatarVideo from "../../assets/bg/diagnostico-2-avatar.webm";
import avatarVideoMp4 from "../../assets/bg/diagnostico-2-avatar.mp4";
import NextButton from "../../components/NextButton";
import flechaAvanzar from "../../assets/right-arrow.svg";
import ScenarioBar from "../../components/ScenarioBar";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario2Intro2({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});


	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted={!canPlayWithSound}
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-end align-items-end bg-diagnostico-a h-100 px-5">
						<div className="recuadro recuadro-orange txtTexto1 w-100">
							<p>Ayuda a Manuel a buscar el informe de laboratorio. Parece que se te ha caído debajo de la mesa el informe... Mira debajo de la mesa...</p>
						</div>
                        <div className="mt-3 w-100">
                            <NextButton
                                navigateTo={ROUTES.SCENARIO2}
                                activeScenario={2}
                                color="orange"
                            />
                        </div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Intro2);
